import { inject, Injectable } from '@angular/core';
import { NgInject } from '@df/ng/ng-inject';
import { Client } from '@df/core/service/client';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { DfModalService } from '@df/ui/modal/df-modal.service';
import { ICmsBlock } from '@icms/core/resource/block/icms-block';
import { ICmsBlockResource } from '@icms/core/resource/block/icms-block.resource';
import { NICmsContentComponent } from '../../../core/content';
import { ICmsContentService } from '../../../core/content/icms-content.service';

@Injectable({ providedIn: 'root' })
export class ICmsModalService extends DfModalService {
    private iCmsBlockResource = inject(ICmsBlockResource);
    private iCmsContentService = inject(ICmsContentService);

    override async loadDependencies(
        modal: NDfModal.IConfig,
        variant?: string,
        options: NDfModal.IOpenOptions = {}
    ): Promise<ICmsBlock | void> {
        const meta = this.iCmsContentService.getComponentMetaByType(modal.component as NICmsContentComponent.ICmsComponentType<any>);
        if (!meta || !meta.block) {
            return;
        }
        const model = await this.iCmsBlockResource.retrieve(
            {
                bareUrl: meta.block.url,
                variant
            },
            undefined
        );
        return model;
    }

    getICmsModals() {
        return this.getAll().filter(i => this.isICmsModal(i));
    }

    protected override onCreateComponent(componentInstance: any, modal: NDfModal.IConfig, variant?: string) {
        componentInstance.modalConfig = <NDfModal.IModalConfig>modal;

        if (modal.type === 'cmsmodal') {
            (componentInstance as NICmsContentComponent.IComponent).variant = variant;
        }
    }

    /**
     * Modal is cms thing if the component it prints is cms one
     */
    private isICmsModal(modal: NDfModal.IConfig) {
        return this.iCmsContentService.getComponentMetaByType(modal.component as NICmsContentComponent.ICmsComponentType<any>);
    }
}
